import CartService from './cartService';
import ErrorMessageCookieService from '../error/errorMessageCookieService';
import {events, UrlService, RunConfigService, ShoppingContext, storage, StringService} from "@nuskin/ns-util";
import {Agelocme} from '@nuskin/ns-product-lib';
import {UserService} from "@nuskin/ns-account";
import {get, forEach} from 'lodash';
import axios from 'axios';
import { getCachedConfigField } from '@nuskin/configuration-sdk';

const ADD = 'add';
const MERGE_PERSISTED_CART= 'merge persisted cart';

let timerId = null;
let mergingIntoLocalCart = false;
let persistingCart = false;
let updateMobileCnt = false;

const persistedItemsMatch = (pItem1, pItem2, matchOnetime = false) => {
    let matches;

    matches = pItem1.sku === pItem2.sku &&
                ((!pItem1.agelocmeCode && !pItem2.agelocmeCode) === true ||
                 (pItem1.agelocmeCode && pItem2.agelocmeCode && pItem1.agelocmeCode === pItem2.agelocmeCode) === true);
    if (matches && matchOnetime) {
        matches = pItem1.oneTime === pItem2.oneTime;
    }

    return matches;
};

const cartItemMatchesPersistedItem = (cItem, pItem, matchOnetime = false) => {
    let matches = false;

    matches = cItem.sku === pItem.sku &&
                ((!cItem.agelocme && !pItem.agelocmeCode) === true ||
                 (cItem.agelocme && pItem.agelocmeCode && cItem.agelocme.code === pItem.agelocmeCode) === true);
    if (matches && matchOnetime) {
        matches = !cItem.isAdr === pItem.oneTime;
    }

    return matches;
}

const cartItemsMatch = (cItem1, cItem2, matchOnetime = false) => {
    let matches = false;

    matches = cItem1.sku === cItem2.sku &&
                ((!cItem1.agelocme && !cItem2.agelocme) === true ||
                 (cItem1.agelocme && cItem2.agelocme && cItem1.agelocme.code === cItem2.agelocme.code) === true);
    if (matches && matchOnetime) {
        matches = cItem1.isAdr === cItem2.isAdr;
    }

    return matches;
}

class PcActions {
    constructor() {
        this.PC_ACTIONS = 'pcActions';
        this.q = storage.getItem(this.PC_ACTIONS);
        if (!this.q) {
            this.q = [];
        }

        this.pcId = this.q.length > 0 ? this.q[0].pcId : 0;
        this.pcVersion = this.q.length > 0 ? this.q[0].pcVersion : 0;
        this.pcType = this.q.length > 0 ? this.q[0].pcType : 0;
    }

    hasItems() {
        return this.q.length > 0;
    }

    hasRemoveCartItem() {
        let retVal = false;

        this.q.forEach((action) => {
            retVal = retVal || action.removeCart;
        });

        return retVal;
    }

    hasLoadCartItem() {
        let type = '';

        this.q.forEach((action) => {
            if (!type && action.loadCart) {
                type = action.loadCart.type;
            }
        });

        return type;
    }

    setInStorage() {
        if (this.q.length > 0) {
            storage.setItem(this.PC_ACTIONS, this.q);
        } else {
            this.pcId = null;
            this.pcVersion = null;
            this.pcType = null;
            storage.removeItem(this.PC_ACTIONS);
        }
    }

    /**
     * Checks to see if two events match on add events.
     *
     * @param srcAdd
     * @param newAdd
     * @return {boolean}
     */
    addProductMatch(srcAdd, newAdd) {
        return !!srcAdd && !!newAdd && cartItemsMatch(srcAdd, newAdd, true);
    }

    /**
     * Checks to see if two events match based on a quantity change event.
     *
     * @param srcModify
     * @param newModify
     * @return {boolean}
     */
    modifyQtyChangeMatch(srcModify, newModify) {
        return !!newModify && !!srcModify &&
            newModify.type === srcModify.type && newModify.type === 'quantity-changed' &&
            cartItemsMatch(srcModify.item, newModify.item, true);
    }

    /**
     * Checks to see if two events match based on an ADR change event.
     * @param srcModify
     * @param newModify
     * @return {boolean}
     */
    adrChangeMatch(srcModify, newModify) {
        return !!newModify && !!srcModify &&
            newModify.type === srcModify.type && newModify.type === 'adr-status-changed' &&
            cartItemsMatch(srcModify.item, newModify.item, false) &&
            srcModify.item.isAdr !== newModify.item.isAdr &&
            srcModify.item.qty === newModify.item.qty;
    }

    /**
     * Takes two events and attempts to merge them together creating
     * a single event between the two of them.
     *
     * @param event
     * @param newEvent
     * @return {boolean}
     */
    mergeCartEvent(event, newEvent) {
        let merged = false;
        const addItem = get(event, 'add.item', null);
        const addNewItem = get(newEvent, 'add.item', null);
        const modify = get(event, 'modify', null);
        const modifyNew = get(newEvent, 'modify', null);

        if (this.addProductMatch(addItem, addNewItem)) {
            addItem.qty += addNewItem.qty;
            merged = true;
        } else if (this.modifyQtyChangeMatch(modify, modifyNew)) {
            modify.qtyDiff += modifyNew.qtyDiff;
            merged = true;
        }/*  else if (this.adrChangeMatch(modify, modifyNew)) {
            modify.item.isAdr = modifyNew.item.isAdr;
            merged = true;
        } */

        return merged;
    }

    syncAdrChange() {
        const cartItems = CartService.getItemData();

        // sync id's in case of previous delete on same item
        this.q.forEach((action) => {
            if (get(action, 'modify.type', '') === 'adr-status-changed') {
                const matchedItems = cartItems.filter((cartItem) => cartItemsMatch(cartItem, action.modify.item));

                if (matchedItems[0]) {
                    action.modify.removeId = matchedItems[0].id;
                }
            }
        });
    }

    peek() {
        this.peeked = 0;
        if (this.q[0]) {
            this.peeked = 1;
        }
        return this.q[0];
    }

    peekNext() {
        let action = null;

        if (this.peeked < this.q.length) {
            action = this.q[this.peeked];
            this.peeked += 1;
        }
        return action;
    }

    clear(num = this.peeked) {
        this.q.splice(0, num);
        this.peeked -= num;
        this.setInStorage();
    }

    setPcInfo(pcId, pcVersion, pcType) {
        this.pcId = pcId;
        this.pcVersion = pcVersion;
        this.pcType = pcType;
    }

    /**
     * Adds a CART_UPDATED event to the queue, merging with a previous
     * event if possible.
     *
     * @param cartAction
     */
    push(cartAction) {
        let merged = false;

        if (cartAction.removeCart || cartAction.loadCart) {
            this.clear();
        }

        forEach(this.q, (action) => {
            if (this.mergeCartEvent(action, cartAction)) {
                merged = true;
                return false;
            }
        });

        if (!merged) {
            this.q.push(cartAction);
        }
        this.pcId = cartAction.pcId;
        this.pcVersion = cartAction.pcVersion;
        this.pcType = cartAction.pcType;
        this.setInStorage();
    }
}

const pcActions = new PcActions();

const getAuthInfo = () => {
    const user = UserService.getUser();
    const anonymousCartId = storage.getItem('anonymousCartId');

    return {
        user,
        anonymousCartId,
        hasInfo: !!user || !!anonymousCartId,
        anonymous: !!anonymousCartId && !user,
        mergeAnonymousCart: !!user && !!anonymousCartId
    }
}

/**
 * Creates a headers object for the AWS service call.
 *
 * @param jwt
 * @returns {{Accept: string, "Content-Type": string, client_id: *, client_secret: *}}
 * @private
 */
const getHeaders = (jwt) => {
    const runConfig = RunConfigService.getRunConfig();
    const headers = {
        'Accept': 'application/json',
        'Content-Type': 'application/json',
        'client_id': runConfig.clientId,
        'client_secret': runConfig.clientSecret
    };
    if (jwt) {
        headers.Authorization = `JWT ${jwt}`;
    }
    return headers;
};

/**
 * Builds the url based on a path term, path param, and queryParams
 *
 * @param path - lambda function term
 * @param pathParam - path parameter appended at the end of the path
 * @param queryParams
 * @return {string}
 * @private
 */
const getUrl = (path, pathParam, queryParams = {}) => {
    const queryStr = UrlService.toQueryString(queryParams);
    const queryString = queryStr.length > 0 ? `?${queryStr}` : '';

    return `${UrlService.getAwsUrl()}/cart/v2/${path}/${pathParam}${queryString}`;
};

/**
 * Gets the persisted cart by accountId
 *
 * @param user
 * @return {Promise<void>}
 */
const getUserCart = async (user, type) => {
    const runConfig = RunConfigService.getRunConfig();

    const response = await axios({
        method: 'GET',
        type: type,
        url: getUrl('getCartByAccountId', user.id, {country: runConfig.country, type: type}),
        headers: getHeaders(user.eid)
    });
    return {pCart: response.data.cart, version: response.data.version};
};

/**
 * Gets an anonymous cart
 *
 * @param user
 * @return {Promise<void>}
 */
const getAnonymousCart = async (cartId, type) => {
    const runConfig = RunConfigService.getRunConfig();

    const response = await axios({
        method: 'GET',
        type: type,
        url: getUrl('getAnonymousCart', cartId, {country: runConfig.country, type: type}),
        headers: getHeaders()
    });
    return {pCart: response.data.cart, version: response.data.version};
};

const mergeAnonymousCart = async (authInfo, type) => {
    const runConfig = RunConfigService.getRunConfig();

    const response = await axios({
        method: 'PUT',
        url: getUrl('mergeAnonymousCart', authInfo.anonymousCartId),
        headers: getHeaders(authInfo.user.eid),
        data: {
            country: runConfig.country,
            type,
            accountId: authInfo.user.id
        }
    })

    storage.removeItem('anonymousCartId');
    return {pCart: response.data.cart, version: response.data.version};
}

const getPersistedCart = async (authInfo, type) => {
    const lsCartType = CartService.getCartProperty('type');
    const lsCartId = CartService.getCartProperty('id');
    let response;

    if (authInfo.mergeAnonymousCart) {
        response = await mergeAnonymousCart(authInfo, type);
    } else if (authInfo.anonymous) {
        response = await getAnonymousCart(authInfo.anonymousCartId, type);
    } else {
        response = await getUserCart(authInfo.user, type);
    }
    const {pCart, version} = response;

    if ((lsCartType !== type) || (pCart && lsCartId && pCart.id !== lsCartId) || (!pCart && lsCartId)) {
        CartService.clearCart();
    }

    if (pCart) {
        CartService.setCartProperties({id: pCart.id, version, type});
    } else {
        CartService.setCartProperties({type: type});
    }

    return pCart;
};

/**
 * This takes an update payload to update the persisted cart with
 *
 * @param user
 * @param cartId
 * @param payload
 * @return {Promise<void>}
 */
const updatePersistedCart = async (user, cartId, payload) => {
    const response = await axios({
        method: 'PUT',
        url: getUrl('updateCart', cartId),
        headers: getHeaders(user.eid),
        data: payload
    });

    const pCart = response.data.cart || null;
    let cartOutdated = response.data.cartOutdated;
    if (cartId && pCart.id !== cartId) {
        CartService.clearCart();
        cartOutdated = pCart.lineItems.length > 0;
    }
    CartService.setCartProperties({id: pCart.id, version: pCart ? response.data.version : -1});
    return {pCart, cartOutdated: cartOutdated, version: response.data.version, type: response.data.type};
};

/**
 * This takes an update payload to update the persisted cart with
 *
 * @param user
 * @param cartId
 * @param payload
 * @return {Promise<void>}
 */
const updateAnonymousPersistedCart = async (cartId, payload) => {
    const response = await axios({
        method: 'PUT',
        url: getUrl('updateAnonymousCart', cartId),
        headers: getHeaders(),
        data: payload
    });

    const pCart = response.data.cart || null;
    let cartOutdated = response.data.cartOutdated;
    if (cartId && pCart.id !== cartId) {
        CartService.clearCart();
        cartOutdated = pCart.lineItems.length > 0;
    }
    CartService.setCartProperties({id: pCart.id, version: pCart ? response.data.version : -1});
    return {pCart, cartOutdated: cartOutdated, version: response.data.version, type: response.data.type};
};

/**
 * Removes a persisted cart
 *
 * @param {object} user
 * @param {string} cartId
 */
const removePersistedCart = async (cartId) => {
    const user = UserService.getUser();
    const {country} = RunConfigService.getRunConfig();

    try {
        if (user && cartId) {
            await axios({
                method: 'DELETE',
                url: getUrl('deleteCart', cartId,  {accountId: user.id, country}),
                headers: getHeaders(user.eid)
            });
            CartService.setCartProperties({id: '', version: -1});
        }
    } catch (err) {
        console.error('Unable to delete persistent cart', err);
    }
};

/**
 * This adds an item from the persisted cart into the local cart.
 *
 * @param pItem
 * @param userId
 * @param country
 * @param language
 * @return {Promise<*>}
 */
const addPersistedItemToLocal = (pItem, userId, country, language) => {
    // Todo If the sku contains letters it is agelocme.  For now don't try to sync the agelocme to local
    return CartService.addSkuToCart({
        id: pItem.id,
        agelocme: pItem.agelocmeCode ? new Agelocme({code: pItem.agelocmeCode, label: pItem.agelocmeLabel, name: pItem.agelocmeName}) : undefined,
        sku: pItem.sku,
        userId: userId,
        cntryCd: country,
        language: language,
        qty: pItem.quantity,
        isAdr: !!pItem.oneTime === false
    });
};

/**
 * This performs a merge on an item from the persisted cart where the local cart
 * has two items with that sku, one adr and one oneTime.
 *
 * @param pItem
 * @param matchedCartItems
 * @return {null}
 */
const mergeOneToOnePlus = (pItem, matchedCartItems) => {
    let promise = null;
    const [cItem1, cItem2] = matchedCartItems;
    const numMatched = matchedCartItems.length;

    if (numMatched === 1) {
        if (cItem1.qty !== pItem.quantity) {
            promise = CartService.changeItemQty(cItem1, pItem.quantity, MERGE_PERSISTED_CART);
        }
        if (cItem1.isAdr === !!pItem.oneTime) {
            CartService.toggleItemAdrStatus(cItem1.key);
        }
    } else {
        const matched = cItem1.isAdr !== !!pItem.oneTime ? cItem1 : cItem2;
        if (matched.qty !== pItem.quantity) {
            promise = CartService.changeItemQty(matched, pItem.quantity, MERGE_PERSISTED_CART);
        }
    }
    return promise;
};

/**
 * This performs a merge on items from the persisted cart into the local cart when
 * there are two products in the persisted cart with the same sku (one adr and one oneTime)
 * as well as two products with the same sku in the local cart.
 *
 * @param pItems
 * @param cItems
 * @return {Array}
 */
const mergeTwoToTwo = (pItems, cItems) => {
    let promises = [];
    const pAdrItem = pItems.find((i) => i.oneTime === false);
    const pItem = pItems.find((i) => i.oneTime === true);
    const cAdrItem = cItems.find((i) => i.isAdr === true);
    const cItem = cItems.find((i) => i.isAdr === false);

    if (pItem.quantity !== cItem.qty) {
        promises.push(CartService.changeItemQty(cItem, pItem.quantity, MERGE_PERSISTED_CART));
    }
    if (pAdrItem.quantity !== cAdrItem.qty) {
        promises.push(CartService.changeItemQty(cAdrItem, pAdrItem.quantity, MERGE_PERSISTED_CART));
    }
    return promises;
};

/**
 * This performs a merge on items from the persisted cart into the local cart when
 * there are two products in the persisted cart with the same sku (one adr and one oneTime)
 * and the sku is only in the local cart once.
 *
 * @param pItems
 * @param cItem
 * @param userId
 * @param country
 * @param language
 * @return {Array}
 */
const mergeTwoToOne = (pItems, cItem, userId, country, language) => {
    let promises = [];
    const pAdrItem = pItems.find((i) => i.oneTime === false);
    const pItem = pItems.find((i) => i.oneTime === true);

    if (cItem.isAdr) {
        if (cItem.qty !== pAdrItem.quantity) {
            promises.push(CartService.changeItemQty(cItem, pAdrItem.quantity, MERGE_PERSISTED_CART));
        }
        promises.push(addPersistedItemToLocal(pItem, userId, country, language));
    } else {
        if (cItem.qty !== pItem.quantity) {
            promises.push(CartService.changeItemQty(cItem, pItem.quantity, MERGE_PERSISTED_CART));
        }
        promises.push(addPersistedItemToLocal(pAdrItem, userId, country, language));
    }
    return promises;
};

/**
 * This to handle cases where an item that is in the persisted cart
 * fails to load into the local cart.  This creates an actions to sync
 * the persisted cart to match the local cart.
 * @param {*} pCart
 */
const adjustPCart = async (pCart) => {
    const errors = ErrorMessageCookieService.getErrorMessages();
    let {savedCartItemsUnavailable, savedCartItemQtyReduced} = await StringService.getStrings([
        {key: 'savedCartItemsUnavailable', dflt: '{sku} in saved cart is not available to be purchased at this time and has been removed.'},
        {key: 'savedCartItemQtyReduced', dflt: 'Quantity of {sku} in saved cart has been reduced due to limitations.'}
    ])
    const cartInfo = CartService.getCartInfo();
    const cartItems = CartService.getItemData()
    pCart.lineItems.forEach((pItem) => {
        let pItemSku = pItem.agelocmeCode || pItem.sku;
        let cItem = cartItems.find((cItem) => cartItemMatchesPersistedItem(cItem, pItem, true));

        if (!cItem || cItem.qty !== pItem.quantity) {
            if (!cItem) {
                errors.addErrorMessage('info', {text: savedCartItemsUnavailable.replace('{sku}', pItemSku), details: ''});
                cItem = {
                    globalProductID: pItem.gpid,
                    sku: pItem.sku,
                    qty: 0,
                    isAdr: !pItem.oneTime,
                    ...(pItem.agelocmeCode && {
                        agelocme: {
                            code: pItem.agelocmeCode,
                            name: pItem.agelocmeName,
                            label: pItem.agelocmeLabel
                        }
                    })
                }
            } else {
                errors.addErrorMessage('info', {text: savedCartItemQtyReduced.replace('{sku}', pItemSku), details: ''});
            }
            pcActions.push({
                modify: {
                    type: 'quantity-changed',
                    item: cItem,
                    qtyDiff: cItem.qty - pItem.quantity
                },
                pcId: cartInfo.id,
                pcType: cartInfo.type,
                pcVersion: cartInfo.version
            });
        }
    });
    ErrorMessageCookieService.setErrorMessages(errors);
};

/**
 * This get the persisted cart (commerce tools) and merges it into the local cart.
 *
 * @param userId
 * @param pCart
 * @return {Promise<void>}
 */
const mergeIntoLocalCart = async (userId, pCart) => {
    //Todo review (seems overly complicated)
    mergingIntoLocalCart = true;
    if (pCart) {
        const {country, language} = RunConfigService.getRunConfig();
        const lineItems = pCart.lineItems || [];
        const pItemsBySku = lineItems.reduce((skuArrs, pItem) => {
            let skuArray = skuArrs.find((arr) => persistedItemsMatch(arr[0], pItem));

            if (!skuArray) {
                skuArray = [pItem];
                skuArrs.push(skuArray);
            } else {
                skuArray.push(pItem);
            }

            return skuArrs;
        }, []);
        const cartItems = CartService.getItemData();
        let promises = [];

        pItemsBySku.forEach((pSkuArray) => {
            if (pSkuArray.length === 1) {
                const pLineItem = pSkuArray[0];
                const matchedCartItems = cartItems.filter((cItem) => cartItemMatchesPersistedItem(cItem, pLineItem));

                if (matchedCartItems.length > 0) {
                    promises.push(mergeOneToOnePlus(pLineItem, matchedCartItems));
                } else {
                    promises.push(addPersistedItemToLocal(pLineItem, userId, country, language));
                }
            } else {
                const cartSkuItems = cartItems.filter((cItem) => cartItemMatchesPersistedItem(cItem, pSkuArray[0]));

                if (cartSkuItems.length === 0) {
                    pSkuArray.forEach((pItem) => promises.push(addPersistedItemToLocal(pItem, userId, country, language)));
                } else if (cartSkuItems.length === 1) {
                    promises = promises.concat(mergeTwoToOne(pSkuArray, cartSkuItems[0], userId, country, language));
                } else if (cartSkuItems.length === 2) {
                    promises = promises.concat(mergeTwoToTwo(pSkuArray, cartSkuItems));
                }
            }
        });

        // Remove local items that do not exist in persisted cart
        cartItems.forEach((cItem) => {
            if (cItem.id) {
                if (!lineItems.some((pItem) => cartItemMatchesPersistedItem(cItem, pItem, true))) {
                    CartService.removeItemByKey(cItem.key);
                }
            }
        });

        await Promise.allSettled(promises);
        await CartService.checkItemAvailability();
        await adjustPCart(pCart);
    }
    mergingIntoLocalCart = false;
};

/**
 * Builds the action for updating a persisted cart.
 *
 * @param action
 * @param {*} data set of data items
 * @return {product: {*}, action: string}
 */
const getAction = (action, data) => {
    let retVal = {action: action};
    const agelocme = data ? data.agelocme : null;

    switch (action) {
        case ADD:
            retVal.product = {
                gpid: data.globalProductID,
                sku: data.sku,
                quantity: data.quantity || data.qty,
                oneTime: !data.isAdr,
                ...(agelocme && {agelocmeCode: agelocme.code}),
                ...(agelocme && {agelocmeName: agelocme.name}),
                ...(agelocme && {agelocmeLabel: agelocme.label})
            };
            break;
        default:
            console.error(`Bad update action: ${action}`);
            break;
    }
    return retVal;
};

/**
 * This takes the items passed in and pesists them.
 *
 * @param cartItems
 * @param authInfo
 * @return {Promise<void>}
 */
const persistLocalItems = async (cartItems, authInfo) => {
    let pCart = null;
    try {
        if (cartItems && cartItems.length > 0) {
            const cartInfo = CartService.getCartInfo();
            const runConfig = RunConfigService.getRunConfig();
            const payload = {
                accountId: authInfo.anonymous ? authInfo.anonymousCartId : authInfo.user.id,
                country: runConfig.country,
                type: cartInfo.type,
                version: cartInfo.version,
                actions: []
            };
            cartItems.forEach((localItem) => {
                payload.actions.push(getAction(ADD, localItem));
            });
            let promise;
            if (authInfo.anonymous) {
                promise = updateAnonymousPersistedCart(cartInfo.id, payload);
            } else {
                promise = updatePersistedCart(authInfo.user, cartInfo.id, payload);
            }
            const response = await promise;
            pCart = response.pCart;
            syncCartItems(pCart);
        }
    } catch (error) {
        if (error.status === 403) {
            // user not allowed to shop in market
            CartService.clearCart();
            events.setValue(events.shop.HOME_MARKET_ONLY_RESTRICTED, true);
        }
        console.error('There was an error persisting local items to cart!', error);
    }
    return pCart;
};

const updateMobile = () => {
    if (window.ReactNativeWebView && updateMobileCnt) {
        window.ReactNativeWebView.postMessage(JSON.stringify({name: 'cart_quantity', payload: CartService.getItemCnt()}));
    }
};

/**
 * This checks to see if the local cart needs to have the persisted cart merged
 * into it.
 *
 * @return {Promise<void>}
 */
const syncCart = async (type) => {
    let authInfo = getAuthInfo();
    let pCart = null;

    if (authInfo.hasInfo && type) {
        try {
            const unPersistedItems = CartService.getItemData().filter(i => !i.id && !i.isBusinessPortfolio);
            if (unPersistedItems.length > 0) {
                pCart = await persistLocalItems(unPersistedItems, authInfo);
            } else {
                pCart = await getPersistedCart(authInfo, type);
            }

            // there is a chance the user got logged out
            authInfo = getAuthInfo();
            if (authInfo.hasInfo) {
                await mergeIntoLocalCart(authInfo.user && authInfo.user.id, pCart);
                if (!timerId) {
                    timerId = setTimeout(timerCallback, 200);
                }
            }
        } catch (err) {
            console.error('Failed to load the persisted cart!', err && err.response && err.response.data ? err.response.data : err);
        }
        if (!authInfo.hasInfo) {
            CartService.clearCart();
        }
    }
    updateMobile();
    events.setValue(events.shop.CART_SYNCED_ON_LOAD, [true]);
};

/**
 * This the ID's in the persisted cart with the ID's in the localStorage cart
 *
 * @param pCart
 */
const syncCartItems = (pCart) => {
    const syncItems = [];
    const cartItems = CartService.getItemData();

    pCart.lineItems.forEach((pItem) => {
        const matchedItem = cartItems.find((item) => cartItemMatchesPersistedItem(item, pItem, true));

        if (matchedItem) {
            syncItems.push({
                id: pItem.id,
                key: matchedItem.key
            });
        } else {
            console.log('Syncing persistent cart. Did not find a matching sku!');
        }
    });

    CartService.setCartProperties({id: pCart ? pCart.id : '' });
    CartService.syncPersistedInfo(syncItems);
};

const doPersistentUpdates = async (actions, pcId, pcVersion, pcType) => {
    try {
        const authInfo = getAuthInfo();
        const payload = {
            accountId: authInfo.anonymous ? authInfo.anonymousCartId : authInfo.user.id,
            country: RunConfigService.getRunConfig().country,
            type: pcType,
            actions: actions,
            version: pcVersion
        };

        let promise;
        if (authInfo.anonymous) {
            promise = updateAnonymousPersistedCart(pcId, payload);
        } else {
            promise = updatePersistedCart(authInfo.user, pcId, payload);
        }
        const {pCart, cartOutdated, version, type} = await promise;
        pcActions.setPcInfo(pCart.id, version, type);
        if (cartOutdated) {
            await mergeIntoLocalCart(authInfo.user && authInfo.user.id, pCart);
        }
        syncCartItems(pCart);
    } catch (err) {
        if (err.status === 403) {
            // user not allowed to shop in market
            CartService.clearCart();
            events.setValue(events.shop.HOME_MARKET_ONLY_RESTRICTED, true);
        }
        console.error('Failed to update persisted cart', err && err.response && err.response.data ? err.response.data : err);
    }
};

const handleAddAction = (addAction, actions) => {
    const item = addAction.item;

    if (!item.isSapLineItem) {
        actions.push(getAction(ADD, item));
    }
};

const handleModifyAction = (modifyAction, actions) => {
    const {type, item, qtyDiff} = modifyAction;

    if (type === 'quantity-changed') {
        if (qtyDiff != 0) {
            actions.push(getAction(ADD, Object.assign({}, item, {quantity: qtyDiff})));
        }
    } else if (type === 'adr-status-changed' || type === 'product-changed') {
        if (modifyAction.removeId) {
            actions.push(getAction(ADD, Object.assign({}, item, {quantity: -item.qty, isAdr: !item.isAdr})));
        }
        actions.push(getAction(ADD, Object.assign({}, item, {quantity: qtyDiff || item.qty})));
    }
};

const handleRemoveAction = (removeAction, actions) => {
    const item = removeAction.item;

    if (item.id) {
        actions.push(getAction(ADD, Object.assign({}, item, {quantity: -item.qty})));
    }
};

const handleRemoveItemsAction = (removeItemsAction, actions) => {
    const removeItems = removeItemsAction.items || [];
    removeItems.forEach((item) => actions.push(getAction(ADD, Object.assign({}, item, {quantity: - item.qty}))));
};

/**
 * Updates the persisted cart based on the CART_UPDATE events that are in
 * the action queue
 *
 * @return {Promise<void>}
 */
const persistCartUpdates = async () => {
    persistingCart = true;
    let {pcId, pcVersion, pcType} = pcActions;
    let actions = [];
    let removeCart = false;
    let loadCartType = null;

    if (pcActions.hasItems()) {
        // even though there is no need to process the queue if there is a removeCart
        // or a loadCart action they still need to get marked as processed so they will
        // get removed.
        let info = pcActions.peek();
        while (info) {
            if (info.removeCart) {
                removeCart = true;
                info = null;
            } else if (info.loadCart) {
                loadCartType = info.loadCart.type;
                info = null;
            } else {
                if (info.add && info.add.item.qty > 0) {
                    handleAddAction(info.add, actions);
                } else if (info.modify) {
                    handleModifyAction(info.modify, actions);
                } else if (info.remove) {
                    handleRemoveAction(info.remove, actions);
                } else if (info.removeItems) {
                    handleRemoveItemsAction(info.removeItems, actions);
                }
                info = pcActions.peekNext();
            }
        }
    }

    if (removeCart) {
        await removePersistedCart(pcId);
    }
    if (loadCartType) {
        await syncCart(loadCartType);
    }
    pcActions.clear();
    if (!(removeCart || loadCartType) && actions.length > 0) {
        await doPersistentUpdates(actions, pcId, pcVersion, pcType);
    }
    updateMobile();
    if (pcActions.hasItems()) {
        clearTimeout(timerId);
        timerId = setTimeout(timerCallback, 200);
    }
    persistingCart = false;
};

const timerCallback = async () => {
    storage.setItem('pcActivity', true);
    pcActions.syncAdrChange();
    await persistCartUpdates();
    storage.removeItem('pcActivity');
};

const getCartType = () => {
    let cartType = null;

    if (!window.location.pathname.startsWith("/content/login/corporate")) {
        const context = ShoppingContext.getShoppingContext();

        if (context) {
            const configCartType = getCachedConfigField('cartType');
            // If cartType is set to context then it takes on the name of of the context,
            // otherwise use what is set
            cartType = configCartType === 'context' ? context.context :
                configCartType === 'none' ? null : configCartType;
        } else {
            cartType = CartService.getCartProperty('type') || 'market';
        }
    }

    return cartType;
}

const addAction = (info) => {
    const authInfo = getAuthInfo();

    if (!getCartType()) {
        pcActions.clear();
    } else if (authInfo.hasInfo && (info.loadCart || !mergingIntoLocalCart)) {
        // If the code is currently merging the persistent cart into the local cart, cart update
        // actions are being generated and those need to be ignored.  A loadCart action is not
        // generated elsewhere and should be let through.
        if (info.add && info.add.item && !info.add.item.isBusinessPortfolio ||
            info.modify || info.remove || info.removeItems || info.removeCart || info.loadCart) {
            pcActions.push(info);
            clearTimeout(timerId);
            timerId = 0;
            if (!persistingCart) {
                if (info.removeCart/*  || pcActions.hasRemoveCartItem() */) {
                    // Likely a page refresh coming, wait for it to happen.
                    // The cart actions will be picked up there.
                    timerCallback().catch(err => console.log('Remove cart error!', err));
                    // timerId = setTimeout(timerCallback, 3000);
                } else if (info.loadCart) {
                    timerId = setTimeout(timerCallback, 0);
                } else {
                    timerId = setTimeout(timerCallback, 200);
                }
            }
        }
    }
};

const loadPersistedCart = (type) => {
    const lsType = CartService.getCartProperty('type');
    if (type != lsType) {
        if (!documentReady) {
            CartService.clearCart();
            CartService.setCartProperties({type: type});
        } else {
            addAction({loadCart: {type: type}});
        }
    }
};

/**
 * Initializes the CART_UPDATED listener and the LOGIN listener.
 */
const initListeners = () => {

    // listener for CART_UPDATED events. As they come in they will get added
    // to a queue with a deloy of 200 ms before processing so if multiple actions
    // come in quickly they can be merged or just collected for processing.
    events.subscribe(events.shop.CART_UPDATED, addAction);

    events.subscribe(events.authentication.LOGIN, function() {
        syncCart(getCartType());
    });
    events.subscribe('get-persisted-cart-type', loadPersistedCart);
    events.subscribe('pause-persistent-cart', () => {
        if (timerId) {
            clearTimeout(timerId);
            timerId = 0;
        }
    });
};

const validPageToSync = () => {
    return window.location.pathname != '/static/checkout/checkout.html' &&
        !window.location.pathname.includes('adp-edit') &&
        !window.location.pathname.includes('adp-manage') &&
        !window.location.pathname.includes('shop.adr-select') &&
        !window.location.pathname.includes('shop.adr-edit')
}

/**
 * Initializes the persistent cart service if market config has it turned on
 * and we are not in any special shopping context.
 *
 * @return {Promise<void>}
 */
const initPersistentCartService = async () => {
    const cartType = getCartType();

    if (cartType) {
        initListeners();
        if (validPageToSync()) {
            updateMobileCnt = false;
            // Persist changed that may not have gotten persisted before page refress
            // like ADR changes that redirect before persisted cart gets updated.
            await persistCartUpdates();

            // now sync persisted cart into local.
            updateMobileCnt = true;
            await syncCart(cartType);
        } else {
            updateMobileCnt = true;
        }
    } else {
        events.setValue(events.shop.CART_SYNCED_ON_LOAD, [true]);
    }
};

// persistentCartService needs to wait until the following configMaps are loaded
// before this service can be initialized.
const neededConfigMaps = ['Loyalty', 'Url', 'Shopping'];

const isSubset = (array1, array2) => {
    return array2.every((element) => array1.includes(element));
}

let documentReady = false;
const csConfigSetCallback = (configs) => {
    if (!documentReady && configs && isSubset(configs, neededConfigMaps)) {
        events.unsubscribe(events.global.CS_CONFIG_SET, csConfigSetCallback);
        if (!window.ReactNativeWebView) {
            initPersistentCartService().then(() => console.log('persisted cart loaded'));
        } else {
            events.getValue(events.mobile.NATIVE_INITIALIZING, (value) => {
                if (value === false) {
                    initPersistentCartService().then(() => console.log('persisted cart loaded'));
                }
            }, true);
        }
    }
}

// This check is so persistent cart does not get initialized on a page
// more than once.  This currently happens in profile.  The side affect here
// is when an item gets added to the cart from the favorites page the separate
// instances of persistent cart take turns persisting the item going from a
// quantity of one to 900+ fairly quickly.
// TODO: this check can be removed once profile is a static app.
if (window.nsPersistentCartInitialized !== true) {
    window.nsPersistentCartInitialized = true;
    // Wait for page to load and them initialize the service
    events.getValue(events.global.CS_CONFIG_SET, csConfigSetCallback, true);
}
storage.removeItem('pcActivity');

export default {
    loadPersistedCart
}
